import { LocaleTranslations } from '@uploadcare/react-widget';

export const emptySetTitle = 'There are no floor plans on this listing yet.';
export const emptySetDescription = 'Upload your own floor plans or order a floor plan service to get started.';

export const floorPlansLocaleTranslations: LocaleTranslations = {
	dialog: {
		tabs: {
			preview: {
				done: 'Confirm selection',
				multiple: {
					done: 'Confirm selection'
				}
			}
		},
		done: 'Confirm selection'
	},
	buttons: {
		choose: {
			files: {
				one: 'upload floor plan file',
				other: 'upload floor plan files'
			},
			images: {
				one: 'upload floor plan image',
				other: 'upload floor plan image'
			}
		}
	}
};
